import type { SVGProps } from "react"

/**
 * Icon for custom boundaries / custom locations: a building-ish footprint
 * being drawn — a notched polygon with dotted edges and vertex handles —
 * with a mouse pointer grabbing its corner. Lucide-compatible: stroke-based,
 * 24×24 viewBox, sized via className like the lucide icons around it.
 */
export function CustomBoundariesIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      {/* Notched, building-like footprint drawn with dotted edges. The
          segment nearest the pointer is left open, as if still being drawn. */}
      <path d="M4 4h9v4h5v6h-4" strokeDasharray="2.4 2.2" />
      <path d="M4 4v10h4" strokeDasharray="2.4 2.2" />
      {/* Vertex handles */}
      <circle cx="4" cy="4" r="1" fill="currentColor" stroke="none" />
      <circle cx="13" cy="4" r="1" fill="currentColor" stroke="none" />
      <circle cx="13" cy="8" r="1" fill="currentColor" stroke="none" />
      <circle cx="18" cy="8" r="1" fill="currentColor" stroke="none" />
      <circle cx="4" cy="14" r="1" fill="currentColor" stroke="none" />
      {/* Mouse pointer grabbing the bottom-right corner */}
      <path
        d="M11.7 12.2 15.4 21l1.3-3.85 3.9-1.3z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  )
}
